import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeSk from '@angular/common/locales/sk';
import localeEn from '@angular/common/locales/en';
import localeCs from '@angular/common/locales/cs';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { AppConfigService } from './services/app-config.service';
import { OtModule } from './ot/ot.module';
import { environment } from 'src/environments/environment';
import { FaIconLibrary, FaConfig } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { CountryService } from './services/country.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    OtModule,
  ],
  providers: [
    AppConfigService,
    CountryService,
    { provide: LOCALE_ID, useValue: environment.locale },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      multi: true,
      deps: []
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary, faConfig: FaConfig) {
    // https://fontawesome.com/icons?d=gallery
    library.addIconPacks(fas, far);
    faConfig.defaultPrefix = 'far';
  }
}

/**
 * Application initialization.
 */
export function initApp() {
  return () => {
    return new Promise((resolve) => {
      registerLocaleData(localeEn);
      registerLocaleData(localeSk);
      registerLocaleData(localeCs);
      resolve();
    });
  };
}
